@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Alaska</h2>
  <!-- Outstanding page PD reject text -->
  @if (baseRules && baseRules?.PD_Reject_Coverage) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.PD_Reject_Text }} </label>
    </div>
  }
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required':
            reactiveForm.get(controls[0].formControlName)?.value === null ||
            reactiveForm.get(controls[0].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        }
      </div>

      @if (baseRules?.BIPD_Text?.includes("show")) {
        <div class="_text-bold">
          {{ textValues.BIPD_Text }}
        </div>
      }
      @if (baseRules?.BI_Text?.includes("show")) {
        <p class="_text-bold">
          {{ textValues.BI_Text }}
        </p>
      }
      @if (baseRules?.PD_Text?.includes("show")) {
        <p class="_text-bold">
          {{ textValues.PD_Text }}
        </p>
      }
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required':
            reactiveForm.get(controls[1].formControlName)?.value === null ||
            reactiveForm.get(controls[1].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </axis-radio-button-wrapper>
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 2; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  ></label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["BIPD_PDSplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[11].label }}</label>
              <div id="bipd_pdsplitminlimits_25k-pdffield-alaska">{{ controls[11].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["BISplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-12 axis-col-lg-12">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="bisplitminlimits_50k_100k-pdffield-alaska">{{ controls[12].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["BIPDCombinedMinSingleLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="bipdcombinedminsinglelimit_125k-pdffield-alaska">{{ controls[8].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["BICombinedMinSingleLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="bicombinedminsinglelimit_100k-pdffield-alaska">{{ controls[9].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Alaska</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_Text }} </label>
    </div>
  }

  <!-- Review page PD reject text -->
  @if (baseRules && baseRules?.PD_Reject_Coverage) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.PD_Reject_Text }} </label>
    </div>
  }

  @if (baseRules?.BIPD_Text?.includes("show")) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues.BIPD_Text }} </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules.BISplitMinLimits_DropDown) {
      <div class="axis-col-sm-12 axis-col-lg-12">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[12].label }} </label>
          <div>{{ controls[12].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.BICombinedMinSingleLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-6">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[9].label }} </label>
          <div>{{ controls[9].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.LiabilityLimit_BI_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-6">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="pdlimits_levelone_radio-pdffield-alaska"
          >
            {{ controls[13].label }}
          </label>
          <div>{{ controls[13].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.LiabilityLimit_BIPD_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="bipdlimits_levelone_radio-pdffield-alaska"
          >
            {{ controls[14].label }}
          </label>
          <div>{{ controls[14].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
